/**
 * Error thrown when Velavu API request fails
 */
export class VelavuRequestError extends Error {
    statusCode;
    raw;
    reason;
    constructor(statusCode, raw) {
        //Try to parse a message from the raw response
        const data = tryParseVelavuRequestErrorData(raw);
        super(data?.message ?? raw);
        this.statusCode = statusCode;
        this.raw = raw;
        this.name = "VelavuRequestError";
        this.reason = data?.reason;
    }
}
/**
 * Error thrown when a resource is not found
 */
export class NotFoundError extends VelavuRequestError {
    constructor(statusCode, raw) {
        super(statusCode, raw);
        this.name = "NotFoundError";
    }
}
/**
 * Error thrown when a resource is forbidden
 */
export class ForbiddenError extends VelavuRequestError {
    constructor(statusCode, raw) {
        super(statusCode, raw);
        this.name = "ForbiddenError";
    }
}
function tryParseVelavuRequestErrorData(text) {
    //Parse the string to JSON
    let parsed;
    try {
        parsed = JSON.parse(text);
    }
    catch {
        return null;
    }
    //Make sure the result is a JSON object
    if (typeof parsed !== "object" || parsed === null) {
        return null;
    }
    //Make sure the object has the required properties
    if (!("reason" in parsed) || typeof parsed.reason !== "string" || !("message" in parsed) || typeof parsed.message !== "string") {
        return null;
    }
    return {
        reason: parsed.reason,
        message: parsed.message
    };
}
export async function responseToVelavuRequestError(response) {
    const text = await response.text();
    switch (response.status) {
        case 404:
            return new NotFoundError(response.status, text);
        case 403:
            return new ForbiddenError(response.status, text);
        default:
            return new VelavuRequestError(response.status, text);
    }
}
//# sourceMappingURL=error.js.map